// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"b632203b291dd0ed","4123":"e6de8a829be95ddb"}[chunkId] + ".css";
};